import { State, DisconnectRule } from '~/models/thing/State'

export const automaticOfflineIn = 1000 * 60 * 10

export const getState = (thing) => {
  const {
    state,
    ts_last_seen: tsLastSeen,
    disconnect_rule: disconnectRule
  } = thing
  if (!state) {
    return State.Default
  }

  // automatically show legacy devices as offline
  //  if it's not last seen within 10 minutes
  if (
    disconnectRule === DisconnectRule.Default &&
    (!tsLastSeen || Date.now() - automaticOfflineIn >= parseInt(tsLastSeen))
  ) {
    return State.Default
  }

  return state.toLowerCase()
}

export const stateChangeIn = (tsLastSeen) => {
  const diff = parseInt(tsLastSeen) + automaticOfflineIn - Date.now()
  return diff > 0 ? diff : false
}

export const getTimeout = (tsLastSeen, callback) => {
  const stateChange = stateChangeIn(tsLastSeen)
  return stateChange ? setTimeout(callback, stateChange) : null
}

export const getIsThingOnline = (localState) => {
  return localState !== State.Gray
}

// A device is considered "offline" (not IoT-connected, e.g. added via Product
// Registration without a Legacy Connector) when it has never reported live data:
// its ts_last_seen is 0/empty and its derived state is gray.
export const getIsOfflineThing = (thing) => {
  if (!thing) return false
  const notSeen = !thing.ts_last_seen || parseInt(thing.ts_last_seen) === 0
  return notSeen && !getIsThingOnline(getState(thing))
}
